import { useI18n as useVueI18n } from "vue-i18n";

/**
 * 国际化 composable
 * 提供语言切换功能
 *
 * 使用示例：
 * ```ts
 * const { t, locale, setLocale } = useLocale()
 * // 使用翻译
 * const text = t('common.confirm')
 * // 切换语言
 * setLocale('en-US')
 * ```
 */
export function useLocale() {
  const { t, locale } = useVueI18n();

  /**
   * 切换语言
   * @param lang 语言代码，如 'zh-CN' 或 'en-US'
   */
  const setLocale = (lang: string) => {
    locale.value = lang;
    localStorage.setItem("locale", lang);
  };

  /**
   * 获取当前语言
   */
  const getLocale = () => {
    return locale.value;
  };

  return {
    t, // 翻译函数
    locale, // 当前语言（响应式）
    setLocale, // 切换语言
    getLocale, // 获取当前语言
  };
}
